import React, { Component } from "react";
import { Icon } from "modules/theme";
import { SidebarList, ModalTrigger, Button } from "modules/theme";
import PropTypes from "prop-types";
import {
  AvtarImg,
  Body,
  DataWrapperClass,
  Header,
  ProfileDiv,
  SidebarBox,
  UserName,
  BodyDiv,
} from "../styles/main";
import ContactListPrivateAddEdit from "../../../../screens/settings/ContactListPrivate/components/ContactListPrivateAddEdit";
import { modalType } from "../../../../../helpers/dotenv";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { globalStateSelector } from "../../../../../store/selector";
import CommonManager from "../../../../../helpers/common";
import styled from "styled-components";
const commonManager = new CommonManager();

const AccordionSection = styled.div`
  .accordionContainer {
    // border-bottom: 1.5px solid #e6eaef;
    background: #f4f8ff;
    border-radius: 8px;
    padding: 10px 10px;
  }
  .header {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    color: #000000;
    margin-right: 25px;
  }
  .section {
  margin: 15px 0px 0px 0px;
  padding: 0px 6px;
}

.section-header {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  color: #272728;
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-checked {
  color: #4CB944;
  font-size: 16px !important;
  font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 48;
}

.section-unchecked {
  color: #D95461;
  font-size: 16px !important;
  font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 48;
}

.count {
  font-size: 12px;
  color: #B1B1B1;
  padding-left: 5px;
}

.topics-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.topic {
  display: flex;
  // justify-content: space-between;
  align-items: center;
}

.topic span {
  font-size: 14px;
font-weight: 600;
line-height: 25px;
letter-spacing: 0.03em;
}

.checked {
  color: #4CB944;
  text-decoration: line-through;
}

.unchecked {
  color: #D95461;
}

.status-icon {
  font-size: 12px;
  margin-right: 8px;
}
`;

export class ContactProfileTheme extends Component {
  constructor(props) {
    super(props);
    this.moduleName = "Contact";
    this.rejectList = [
      "_id",
      "phone_number",
      "publicInfo",
      "updateBy",
      "update_at",
      "listId",
      "listName",
    ];
    this.state = {
      showHide: false,
      modalType: modalType,
      contactId: this.props.custInfo.objInfo
        ? this.props.custInfo.objInfo._id
        : "" || "",
      editData: null,
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModals = this.openModals.bind(this);

    console.log('props.callChecklist', props.callChecklist)
  }
  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps", nextProps);
    // this.setState(nextProps);
  }
  toTitleCaseWithSpaces = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
      .replace(/(^|\s)\S/g, (group) => group.toUpperCase()); // Capitalize the first letter of each word
  };

  renderDetails(title, text) {
    return (
      // <BodyDiv className={""}>
      //   <span className="title">{title}</span>
      //   <div className={text == "Not available" ? "text-secondary" : "text"}>
      //     {text}
      //   </div>
      // </BodyDiv>
      <table className="details-table" style={{ width: "auto", marginTop: '10px' }}>
        <tbody>
          <tr>
            <td className="long-value-row detail-key" style={{ width: '75px' }}>{this.toTitleCaseWithSpaces(title)}: </td>
            <td className={`${text == "Not available" ? "text-secondary" : "text"} detail-value pl-3`} style={{ wordBreak: 'break-all' }}>{text}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  closeModal(isUpdated, customerData) {
    // console.log('isUpdated', isUpdated, customerData);
    this.setState({ showHide: false });
    if (
      isUpdated &&
      this.props.custInfo &&
      this.props.custInfo.objInfo &&
      this.props.custInfo.objInfo._id &&
      this.props.getList
    ) {
      setTimeout(() => {
        this.props.getList(
          this.props.custInfo.info ? this.props.custInfo.info.phone_number : "",
          this.props.custInfo.objInfo
            ? this.props.custInfo.objInfo._id
            : "" || ""
        );
      }, 3000);
    }
  }
  openModals(data) {
    console.log("aaaa", data);
    if (data) {
      this.setState({ editData: data, showHide: true });
    } else {
      this.setState({ showHide: true });
    }
  }

  renderActionBar(data) {
    console.log("dataaaa", data);
    {
      console.log("this.props.listData", this.props.listData);
    }
    const importTrigger = (
      <Button
        btnStyle="link"
        className="bg-light p-2"
        size="small"
        icon="edit"
        onClick={() => this.openModals(data)}
      />
    );
    // console.log('editDataaa', this.state.editData);
    // console.log('constactId', this.state.contactId);

    return (
      <ModalTrigger
        title={this.moduleName}
        trigger={importTrigger}
        size="md"
        showHide={this.state.showHide}
        closeModal={this.closeModal}
        openModal={() => this.openModals(data)}
        dialogClassName={this.state.modalType}
      >
        <ContactListPrivateAddEdit
          size="small"
          isEdit={false}
          editData={this.state.editData}
          // CountryList={this.state.CountryList}
          modalType={this.state.modalType}
          closeModal={this.closeModal}
          // closeModal={()=>{this.setState({ showHide: false });}}
          contactId={
            this.props.custInfo.objInfo
              ? this.props.custInfo.objInfo._id
              : "" || ""
          }
          listField={
            this.props.custInfo.objInfo
              ? this.props.custInfo.objInfo.fields
              : ""
          }
          getList={
            this.props.getList
              ? () =>
                this.props.getList(
                  (this.props.custInfo.info &&
                    this.props.custInfo.info.phone_number) ||
                  "",
                  (this.props.custInfo.objInfo &&
                    this.props.custInfo.objInfo._id) ||
                  ""
                )
              : () => { }
          }
        />
      </ModalTrigger>
    );
  }

  componentDidMount() {
    // console.log(this.props.teamList,'hereeee')
    // console.log(this.props.team,'hereeee','team')
  }

  render() {
    const { __ } = this.context;
    let _this = this;
    const { teamList, team, callTeam } = this.props;

    let numberMask = {};
    let phone_number = this.props.custInfo.info
      ? this.props.custInfo.info.phone_number
      : "";
    try {
      teamList.map((e) => {
        numberMask[e._id] = e.numberMasking || false;
      });
    } catch (error) { }
    return (
      <DataWrapperClass>
        <ProfileDiv
          className="w-100"
          style={{
            padding: "10px 15px",

          }}
        >
          <AvtarImg>
            <img src="/images/LoginAgent.png" style={{ width: "40px" }} />
          </AvtarImg>
          <UserName className="overflow-hidden text-truncate flex-grow-1">
            {/* {this.props.listData.map(data => {
                               console.log('data',data);
                            data.objInfo.name
                           })} */}
            {console.log("customer info name", this.props.custInfo.info)}
            <h3 className="m-0" style={{ fontSize: "18px" }}>
              {_this.props.custInfo.info &&
                (this.props.custInfo.info.name || this.props.custInfo.info.Name)
                ? _this.props.custInfo.info.name ||
                _this.props.custInfo.info.Name
                : "No Name"}
            </h3>
            {/* {console.log(this.props.custInfo.info,'hereeeeee')} */}
            {/* <br /> */}
            <p className="m-0" style={{ fontSize: "14px" }}>
              {
                (phone_number =
                  callTeam &&
                    callTeam._id &&
                    numberMask[`${callTeam._id}`] === true
                    ? commonManager.maskText(phone_number)
                    : typeof phone_number === "string" &&
                      phone_number.length > 13
                      ? phone_number.substring(0, 13) + "..."
                      : phone_number)
              }
            </p>
            {/* <div>{_this.props.custInfo.info ? _this.props.custInfo.info.phone_number : ''}</div> */}
          </UserName>
          {/* <span className='active-sign'><Icon icon="edit"></Icon></span> */}
          {_this.renderActionBar(_this.props.custInfo.info)}
        </ProfileDiv>
        {/* <hr
          style={{
            borderTop: "0.7px dashed #303030",
            margin: "0px 20px 0px 20px",
            opacity: "0.2",
          }}
        /> */}
        <SidebarList>
          <SidebarBox
            style={{
              height: "calc(100vh - 150px)",
              // height: "100%",
              overflowY: 'auto',
              margin: "0px 0px 0px 6px",
              padding: "0px",
              borderRadius: "0px 0px 0px 10px",
              background: "transparent",
              borderTop: "1px solid rgb(226, 232, 239)",
            }}
          >
            <div className="pl-4 pr-4 pt-4">
              <Header className="m-0">Personal Information</Header>
            </div>
            <div
              className="pl-6 pr-5"
            // style={{ height: "calc(100vh - 205px)", overflow: "auto", padding: '6px' }}
            >
              {_this.props.listField &&
                this.props.listField.length !== 0 &&
                _this.props.custInfo.info
                ? _this.props.listField.map((key) => {
                  let value =
                    _this.props.custInfo.info[key] || "Not available";
                  value = typeof value == "string" ? value : "";
                  if (
                    _this.rejectList &&
                    _this.rejectList.indexOf(key) > -1
                  ) {
                    return <React.Fragment />;
                  }
                  return _this.renderDetails(key, value);
                })
                : "No Information"}
            </div>
            <hr style={{ marginTop: "15px", marginBottom: "15px" }} />
            <div className="pl-4 pr-4">
              <Header className="m-0">AI Checklist</Header>
            </div>
            <AccordionSection className="pl-5 pr-5 mb-4">
              {this.props.callChecklist && Array.isArray(this.props.callChecklist) && this.props.callChecklist.map((section, sectionIndex) => (
                <div key={sectionIndex} className="section">
                  <div className="section-header">
                    <div className="">
                      <span>{section.name}</span>
                      <span className="count">
                        ({section.topics.filter((topic) => topic.checked).length}/
                        {section.topics.length})
                      </span>
                    </div>
                    {section.topics.filter((topic) => topic.checked).length === section.topics.length && (
                      <span class="material-symbols-outlined section-checked">
                        check_circle
                      </span>
                    )}
                  </div>
                  <ul className="topics-list">
                    {section.topics.map((topic, topicIndex) => (
                      <li key={topicIndex} className={`topic ${topic.checked ? 'checked' : 'unchecked'}`}>
                        {/* <span className={`status-icon ${topic.checked ? 'checked' : 'unchecked'}`}> */}
                        {topic.checked ? <span class="material-symbols-outlined section-checked pr-3">
                          check_circle
                        </span> : <span class="material-symbols-outlined section-unchecked pr-3">
                          info
                        </span>}
                        {/* </span> */}
                        <span>{topic.topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </AccordionSection>
          </SidebarBox>
        </SidebarList>
      </DataWrapperClass>
    );
  }
}

ContactProfileTheme.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  teamName: globalStateSelector.getDynamic(state, { key: "dialPadTeamName" }),
  callLoader: globalStateSelector.getDynamic(state, {
    key: "callHandlingLoader",
  }),
  callTeam: globalStateSelector.getDynamic(state, { key: "callTeam" }),
  callChecklist: globalStateSelector.getCallChecklist(state),
});

// const dispatchToProps = dispatch => ({
//   dynamicUpdate: data => {
//     dispatch(globalAction.dynamicUpdate({data}));
//   },
// });

export default connect(stateToProps)(withRouter(ContactProfileTheme));



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactProfileTheme.js